import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import flatten from 'lodash/flatten';
import generateBlockId from '../../utils/generateBlockId';
import { BLOCK, INLINE, TEXT, MARK } from '../../../types/SlateTypes';
import EntityTypes from '../../../types/EntityTypes';
import { LINE_BREAK_CHARACTER } from '../../constants';
var FORBIDDEN_PARENTS = ['COLGROUP', 'TABLE', 'TBODY', 'TR'];

var makeDefaultNodeDeserializers = function makeDefaultNodeDeserializers(_ref) {
  var TAGNAME_TO_BLOCK = _ref.TAGNAME_TO_BLOCK,
      TAGNAME_TO_ENTITY = _ref.TAGNAME_TO_ENTITY,
      TAGNAME_TO_MARK = _ref.TAGNAME_TO_MARK;
  return function (el, next) {
    if (TAGNAME_TO_BLOCK[el.tagName]) {
      if (typeof TAGNAME_TO_BLOCK[el.tagName] === 'function') {
        return TAGNAME_TO_BLOCK[el.tagName](el, next);
      }

      return {
        object: BLOCK,
        type: TAGNAME_TO_BLOCK[el.tagName],
        data: {
          id: generateBlockId()
        },
        nodes: next(el.childNodes)
      };
    } else if (TAGNAME_TO_ENTITY[el.tagName]) {
      if (typeof TAGNAME_TO_ENTITY[el.tagName] === 'function') {
        return TAGNAME_TO_ENTITY[el.tagName](el, next);
      }

      return {
        object: INLINE,
        type: TAGNAME_TO_ENTITY[el.tagName],
        data: {
          entityId: generateBlockId()
        },
        nodes: next(el.childNodes)
      };
    } else if (TAGNAME_TO_MARK[el.tagName]) {
      if (typeof TAGNAME_TO_MARK[el.tagName] === 'function') {
        return TAGNAME_TO_MARK[el.tagName](el, next);
      }

      return {
        object: MARK,
        type: TAGNAME_TO_MARK[el.tagName],
        nodes: next(el.childNodes)
      };
    } else if (el.nodeName === '#text') {
      if (el.parentElement && el.parentElement.style && ['pre', 'pre-wrap', 'pre-line'].includes(el.parentElement.style.whiteSpace)) {
        var blocks = el.nodeValue.split('\n');
        return flatten(blocks.map(function (block, index) {
          return [].concat(_toConsumableArray(index > 0 ? [{
            object: INLINE,
            type: EntityTypes.LINE_BREAK,
            data: {
              entityId: generateBlockId()
            },
            nodes: [{
              object: TEXT,
              text: LINE_BREAK_CHARACTER
            }]
          }] : []), [{
            object: TEXT,
            text: block
          }]);
        }));
      }

      var text = el.nodeValue.replace(/^(\n+)$/gm, '').replace(/\n+/g, ' ');

      if (!text.length || FORBIDDEN_PARENTS.includes(el.parentElement.nodeName)) {
        return null;
      }

      return {
        object: TEXT,
        text: text
      };
    } else if (el.nodeName === '#comment') {
      return null;
    }
  };
};

export default makeDefaultNodeDeserializers;